export default "__VITE_ASSET__918hTvax__";